import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Form, Button, Input, message } from "antd";
import { API, history, imgRoot } from "../../static/js/common";

const FormItem = Form.Item;
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPwdLogin: false,
      is_send: false,
      getcode: "获取验证码",
      phone: "",
    };
  }

  componentDidMount() {
  }

  waitingVefiry = () => {
    // 获取验证码倒计时
    let countdown = 60;
    if (this.state.is_send) return;
    clearInterval(window._verify_timer);
    window._verify_timer = null;
    this.setState({
      is_send: true,
      getcode: `${countdown}s后重新获取`,
    });
    window._verify_timer = setInterval(() => {
      countdown--;
      let tips = `${countdown}s后重新获取`,
        send = true;
      if (countdown === 0) {
        clearInterval(window._verify_timer);
        tips = "获取验证码";
        send = false;
      }
      this.setState({ getcode: tips, is_send: send });
    }, 1000);
  };

  getVerifyCode = () => {
    // 获取验证码
    const { phone, is_send } = this.state;
    if (is_send) return;
    const mobile = phone.replace(/\s/g, "");
    if (
      !/^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/.test(
        mobile
      )
    ) {
      message.error("手机号码输入有误！", 1.2);
      return;
    }
    API.getSmsCode({
      mobile,
      // sendType: "userRegister",
    }).then((res) => {
      if (res.status * 1 === 0) {
        message.success("发送成功", 1.2);
        this.waitingVefiry();
      } else {
        message.error(res.message || "验证码发送失败！", 1.2);
        this.setState({
          is_send: false,
        });
      }
    });
  };

  onSubmit = (values) => {
    const { isPwdLogin } = this.state;
    const fr  = window.localStorage.getItem("from-origin");
    const inviteCode  = window.localStorage.getItem("invite-code");
    const { mobile, password, verifyCode } = values;
    if (
      !/^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/.test(
        mobile
      )
    ) {
      message.error("请输入正确的手机号");
      return;
    }
    if (isPwdLogin) {
      const params = { mobile, password, channel: 2 , fr}
      if(inviteCode) {
        params.inviteCode = inviteCode
      }
      API.postLogin(params).then((res) => {
        if (res.status * 1 === 0) {
          history.push("/?tabKey=all");
          window.localStorage.setItem("dfToken", res.extData.token);
        } else {
          message.error(res.message || "登录错误");
        }
      });
    } else {
      const params = { mobile, captcha: verifyCode, channel: 2, fr}
      if(inviteCode) {
        params.inviteCode = inviteCode
      }
        API.postCaptchaLogin(params).then((res) => {
        if (res.status * 1 === 0) {
          history.push("/?tabKey=all");
          window.localStorage.setItem("dfToken", res.extData.token);
        } else {
          message.error(res.message || "登录错误");
        }
      });
    }
  };

  toRegister = () => {
    window.open("https://df.duoduolang.com/#/register?tabKey=login", "_target")
  };

  render() {
    const { isPwdLogin, getcode } = this.state;
    const prefix_login = (
      <div className="prefix">
        <img alt="" src={`${imgRoot}/username.png`} />
      </div>
    );
    const prefix_pwd = (
      <div className="prefix">
        <img alt="" src={`${imgRoot}/pwd.png`} />
      </div>
    );
    return (
      <div className="login">
        <main className="login_bg">
          {/*  <img
            alt=""
            width="100%"
            style={{ zIndex: -1 }}
            src={`${imgRoot}/background.jpg`}
          /> */}
          <div className="background_color"></div>
          <div className="log_box">
            <div style={{ position: "relative" }}>
              <div className="log_content">
                <img width="660" alt="" src={`${imgRoot}/login1.png`} />
                <div className="login_box1">
                  <p className="login_text">登录</p>
                  <Form onFinish={this.onSubmit}>
                    <FormItem
                      name="mobile"
                      rules={[
                        {
                          required: true,
                          message: "请输入手机号",
                        },
                      ]}
                    >
                      <Input
                        prefix={prefix_login}
                        placeholder="请输入手机号"
                        onChange={(e) =>
                          this.setState({ phone: e.target.value })
                        }
                      />
                    </FormItem>
                    {isPwdLogin ? (
                      <FormItem
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "请输入密码",
                          },
                        ]}
                        style={{ marginBottom: 6 }}
                      >
                        <Input
                          prefix={prefix_pwd}
                          type="password"
                          placeholder="请输入密码"
                        />
                      </FormItem>
                    ) : (
                      <FormItem
                        name="verifyCode"
                        rules={[
                          {
                            required: true,
                            message: "请输入验证码",
                          },
                        ]}
                        style={{ marginBottom: 6 }}
                      >
                        <Input
                          placeholder="请输入验证码"
                          addonAfter={
                            <div
                              className="get_code"
                              onClick={this.getVerifyCode}
                            >
                              {getcode}
                            </div>
                          }
                        />
                      </FormItem>
                    )}
                    <div
                      style={{
                        color: "#33AAFF",
                        cursor: "pointer",
                        marginTop: 12,
                      }}
                      onClick={() => this.setState({ isPwdLogin: !isPwdLogin })}
                    >
                      {isPwdLogin ? "短信验证码登录" : "账号密码登录"}
                    </div>
                    <FormItem>
                      <Button className="btn" htmlType="submit">
                        登录
                      </Button>
                    </FormItem>
                  </Form>
                  <div className="flex-space">
                    <Link to="/forget?tabKey=login">
                      <div onClick={(_) => this.setState({ tabKey: "seller" })}>
                        忘记密码
                      </div>
                    </Link>
                    <Link to="/register?tabKey=login">
                      {/* <div onClick={(_) => this.toRegister()} style={{cursor: 'pointer'}}>
                        新用户注册
                      </div> */}
                      <div onClick={(_) => this.setState({ tabKey: "seller" })}>
                        新用户注册
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}
export default Login;
